export const abStatsFrag = `
    data
    batchNumber
    totalBatches
    error
`;
